import { App } from 'vue'
import Toast from 'vue-toastification'

import 'vue-toastification/dist/index.css'

export default function install(app: App<Element>) {
  app.use(Toast)
}
